    
const KLAVIYO_PUBLIC_KEY = 'YxZeT5';
const LIST_ID = "VwWssX";

(function() {
  const TOTAL_STEPS = 7;
  let currentStep = 1;
  const selections = {};

  const costs = {
    single: {
      damp: [200, 600],
      insulation: [400, 900],
      electrical: [500, 1200],
      ventilation: [150, 600],
      lighting: [100, 300],
      flooring: [200, 500]
    },
    '1.5': {
      damp: [280, 800],
      insulation: [550, 1200],
      electrical: [550, 1350],
      ventilation: [200, 750],
      lighting: [150, 400],
      flooring: [280, 700]
    },
    double: {
      damp: [350, 1000],
      insulation: [700, 1500],
      electrical: [600, 1500],
      ventilation: [250, 900],
      lighting: [200, 500],
      flooring: [350, 900]
    }
  };

  const garageLabels = {
    single: 'Single garage',
    '1.5': 'Oversized single garage',
    double: 'Double garage'
  };

  const stateLabels = {
    bare: 'Bare brick & concrete',
    partial: 'Partially converted',
    power: 'Has power already'
  };

  function fmt(n) {
    return '£' + n.toLocaleString('en-GB');
  }

  function range(arr) {
    return fmt(arr[0]) + ' – ' + fmt(arr[1]);
  }

  // Build progress indicators
  function buildProgress() {
    const wrap = document.getElementById('progressSteps');
    wrap.innerHTML = '';
    for (let i = 1; i <= TOTAL_STEPS; i++) {
      const el = document.createElement('div');
      el.className = 'progress-step' + (i === 1 ? ' active' : '');
      el.textContent = i;
      el.id = 'pStep' + i;
      wrap.appendChild(el);
    }
  }

  function updateProgress() {
    for (let i = 1; i <= TOTAL_STEPS; i++) {
      const el = document.getElementById('pStep' + i);
      el.className = 'progress-step';
      if (i < currentStep) el.className += ' done';
      if (i === currentStep) el.className += ' active';
    }
    const pct = ((currentStep - 1) / (TOTAL_STEPS - 1)) * 100;
    document.getElementById('progressFill').style.width = pct + '%';
  }

  function showStep(n) {
    document.querySelectorAll('.step-card').forEach(c => c.classList.remove('active'));
    const card = document.querySelector('[data-step="' + n + '"]');
    if (card) card.classList.add('active');
    updateProgress();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // Option selection
  document.querySelectorAll('.options-group').forEach(group => {
    const field = group.dataset.field;
    group.querySelectorAll('.option-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        group.querySelectorAll('.option-btn').forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        selections[field] = btn.dataset.value;
        checkStep1();
        if (field === 'garageType') updateCosts();
      });
    });
  });

  function checkStep1() {
    const ready = selections.garageType && selections.garageState && selections.attached;
    document.getElementById('btn1').disabled = !ready;
  }

  function updateCosts() {
    const g = selections.garageType || 'single';
    const c = costs[g];
    document.getElementById('cost-damp').textContent = range(c.damp);
    document.getElementById('cost-insulation').textContent = range(c.insulation);
    document.getElementById('cost-electrical').textContent = range(c.electrical);
    document.getElementById('cost-ventilation').textContent = range(c.ventilation);
    document.getElementById('cost-lighting').textContent = range(c.lighting);
    document.getElementById('cost-flooring').textContent = range(c.flooring);
  }

  window.nextStep = function() {
    if (currentStep === 1) {
      updateCosts();
      // Show attached/detached note on electrical step
      if (selections.attached === 'attached') {
        document.getElementById('attached-note').style.display = 'block';
        document.getElementById('detached-note').style.display = 'none';
      } else {
        document.getElementById('attached-note').style.display = 'none';
        document.getElementById('detached-note').style.display = 'block';
      }
    }
    if (currentStep < TOTAL_STEPS) {
      currentStep++;
      showStep(currentStep);
    }
  };

  window.prevStep = function() {
    if (currentStep > 1) {
      currentStep--;
      showStep(currentStep);
    }
  };

  window.showPopup = function() {
    // showResults()
    document.getElementById('gateWrapper').classList.add('locked');
    window.scrollTo({ top: 100, behavior: 'smooth' });

  };

  window.unlockGate = function() {
    const name = document.getElementById('gateName').value.trim();
    const email = document.getElementById('gateEmail').value.trim();
    const errEl = document.getElementById('gateError');

    if (!name || !email) {
        errEl.textContent = 'Please enter your name and email.';
        errEl.style.display = 'block';
        return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        errEl.textContent = 'Please enter a valid email address.';
        errEl.style.display = 'block';
        return;
    }

     errEl.style.display = 'none';

      let costData = {
        damp: document.getElementById("cost-damp")?.innerText || "",
        insulation: document.getElementById("cost-insulation")?.innerText || "",
        electrical: document.getElementById("cost-electrical")?.innerText || "",
        ventilation: document.getElementById("cost-ventilation")?.innerText || "",
        lighting: document.getElementById("cost-lighting")?.innerText || "",
        flooring: document.getElementById("cost-flooring")?.innerText || ""
    };

      /* Get selected options */
      let selectionsTemp = {};
      document.querySelectorAll('.options-group').forEach(group => {
          const field = group.dataset.field;
          const active = group.querySelector('.option-btn.selected');
          if(active){
              selectionsTemp[field] = active.dataset.value;
          }
      });

    const costSummary = Object.entries(costData)
    .map(([key, value]) => `${key} | ${value}`)
    .join('<br>');

    const selectionsSummary = Object.entries(selectionsTemp)
    .map(([key, value]) => `${key} | ${value}`)
    .join('<br>');

  
    var listPayload = {
          data: {
            type: "subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: email,
                    first_name: name.split(" ")[0],
                    last_name: name.split(" ").slice(1).join(" "),                 
                  }
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: "list",
                  id: LIST_ID
                }
              }
            }
          }
        };

        fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + KLAVIYO_PUBLIC_KEY, {
          method: "POST",
          headers: {
            "Content-Type": "application/vnd.api+json",
            "revision": "2024-10-15"
          },
          body: JSON.stringify(listPayload)
        });



        var eventPayload = {
              data: {
                type: "event",
                attributes: {
                  metric: {
                    data: {
                      type: "metric",
                      attributes: {
                        name: "Garage Gym Planner Lead Captured"
                      }
                    }
                  },
                  profile: {
                    data: {
                      type: "profile",
                      attributes: {
                        email: email,
                        first_name: name
                      }
                    }
                  },
                  properties: {
                    selections: selectionsSummary,
                    cost_breakdown: costSummary,
                    source: "Garage Gym Planner"
                  }
                }
              }
            };

            fetch("https://a.klaviyo.com/client/events/?company_id=" + KLAVIYO_PUBLIC_KEY, {
              method: "POST",
              headers: {
                "Content-Type": "application/vnd.api+json",
                "Accept": "application/vnd.api+json",
                "revision": "2024-10-15"
              },
              body: JSON.stringify(eventPayload)
            });



    document.getElementById('gateWrapper').classList.remove('locked');  
    showResults();
};

  window.showResults = function() {
    const g = selections.garageType || 'single';
    const c = costs[g];

    // Summary
    document.getElementById('results-summary').textContent =
      garageLabels[g] + ' · ' + stateLabels[selections.garageState || 'bare'] +
      ' · ' + (selections.attached === 'attached' ? 'Attached' : 'Detached');

    // Timeline
    const hasElectrical = selections.garageState !== 'power';
    const timelineData = [
      { week: 'Week 1', title: 'Damp-Proofing', desc: 'Tanking slurry (2 coats) + DPM on floor. Allow curing time.' },
      { week: 'Week 2', title: 'Insulation', desc: 'Walls, floor insulation + battens. Leave ceiling for after electrical.' },
      { week: 'Week 2–3', title: 'Electrical First Fix', desc: hasElectrical ? 'New circuit, cable runs behind walls, socket and light positions.' : 'Check existing circuit is adequate. Add sockets if needed.' },
      { week: 'Week 3', title: 'Plasterboarding & Finishing', desc: 'Board walls and ceiling over insulation and cables.' },
      { week: 'Week 3–4', title: 'Ventilation + Electrical Second Fix', desc: 'Install extractor fan, vents, heater. Fit sockets, switches, and LED panels.' },
      { week: 'Week 4', title: 'Flooring', desc: 'Lay rubber tiles or rolled rubber. The fun bit.' },
      { week: 'Week 4+', title: 'Equipment & Finishing Touches', desc: 'Move in equipment, mirrors, storage, and start training!' }
    ];

    const tl = document.getElementById('timeline');
    tl.innerHTML = '';
    timelineData.forEach(item => {
      tl.innerHTML += '<div class="timeline-item">' +
        '<div class="timeline-week">' + item.week + '</div>' +
        '<div class="timeline-title">' + item.title + '</div>' +
        '<div class="timeline-desc">' + item.desc + '</div></div>';
    });

    // Cost summary
    const phases = [
      ['Damp-proofing', c.damp],
      ['Insulation', c.insulation],
      ['Electrical', c.electrical],
      ['Ventilation & heating', c.ventilation],
      ['Lighting', c.lighting],
      ['Flooring', c.flooring]
    ];

    let totalLow = 0, totalHigh = 0;
    let html = '';
    phases.forEach(p => {
      totalLow += p[1][0];
      totalHigh += p[1][1];
      html += '<div class="cost-row"><span class="cost-label">' + p[0] + '</span><span class="cost-value">' + range(p[1]) + '</span></div>';
    });
    html += '<div class="cost-total"><span>Total (excl. equipment)</span><span>' + fmt(totalLow) + ' – ' + fmt(totalHigh) + '</span></div>';
    document.getElementById('costSummary').innerHTML = html;

    // Show results
    document.querySelectorAll('.step-card').forEach(c => c.classList.remove('active'));
    document.querySelector('[data-step="results"]').classList.add('active');

    // Update progress to complete
    for (let i = 1; i <= TOTAL_STEPS; i++) {
      document.getElementById('pStep' + i).className = 'progress-step done';
    }
    document.getElementById('progressFill').style.width = '100%';
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  window.captureEmail = function() {
    const input = document.getElementById('emailInput');
    const email = input.value.trim();
    if (email && email.includes('@')) {
      document.getElementById('emailSuccess').style.display = 'block';
      input.style.display = 'none';
      input.parentElement.querySelector('.btn-primary').style.display = 'none';
      // In production: send to Klaviyo or your email service here
      // Example: fetch('/api/lead', { method: 'POST', body: JSON.stringify({ email, plan: selections }) });
    } else {
      input.style.borderColor = '#dc3545';
      input.setAttribute('placeholder', 'Please enter a valid email');
    }
  };

  window.restart = function() {
    currentStep = 1;
    Object.keys(selections).forEach(k => delete selections[k]);
    document.querySelectorAll('.option-btn').forEach(b => b.classList.remove('selected'));
    document.getElementById('btn1').disabled = true;
    document.getElementById('emailInput').style.display = '';
    document.getElementById('emailSuccess').style.display = 'none';
    const sendBtn = document.querySelector('.email-row .btn-primary');
    if (sendBtn) sendBtn.style.display = '';
    showStep(1);
  };

  window.toggleExpand = function(trigger) {
    const content = trigger.nextElementSibling;
    const arrow = trigger.querySelector('.expand-arrow');
    content.classList.toggle('open');
    arrow.classList.toggle('open');
  };

  // Init
  buildProgress();
  updateCosts();
})();